import AmazonECS from './AmazonECS'

export default AmazonECS
